/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import _ from 'lodash';

import common from '@common';
import { getActiveDateRange } from '../../schedule/helpers';

const {
  calendar: {
    constants: { SCHEDULE_MODE, SCHEDULE_SUBJECT, SCHEDULE_TYPE },
    helpers: { cloneDate, getWeekBegin },
  },
  utils: {
    dimension: { DIMENSION_STATES, getDimensions },
    regexHelper: { getScheduleDateFromPath },
  },
} = common;

export const getScheduleInitialState = () => {
  const pathname = _.get(window, 'location.pathname', '');
  const dimensionState = _.get(getDimensions(), 'state', DIMENSION_STATES.DESKTOP);
  const isScheduleRoute = _.includes(pathname, 'schedule');
  const includesMobilePath = _.includes(pathname, SCHEDULE_TYPE.MOBILE);
  const isMobileView = dimensionState === DIMENSION_STATES.MOBILE;
  const isWeeklyDaily = _.some([SCHEDULE_MODE.DAILY, SCHEDULE_MODE.WEEKLY], mode =>
    _.includes(pathname, mode),
  );

  const pathDate = getScheduleDateFromPath(pathname);
  const startDateMoment = pathDate ? moment(pathDate) : moment();

  let initialDate = getWeekBegin(startDateMoment);
  let initialMode = SCHEDULE_MODE.WEEKLY;
  let initialSubject = SCHEDULE_SUBJECT.PROPERTY;
  let initialType = SCHEDULE_TYPE.DESKTOP;

  if (_.includes(pathname, SCHEDULE_SUBJECT.USER_PLANNING)) {
    initialDate = cloneDate(startDateMoment);
    initialMode = SCHEDULE_MODE.DAILY;
    initialSubject = SCHEDULE_SUBJECT.USER_PLANNING;
  } else if (_.includes(pathname, SCHEDULE_SUBJECT.USER)) {
    initialSubject = SCHEDULE_SUBJECT.USER;
  }

  if (_.includes(pathname, SCHEDULE_MODE.DAILY)) {
    initialDate = cloneDate(startDateMoment);
    initialMode = SCHEDULE_MODE.DAILY;
  }

  if (_.includes(pathname, SCHEDULE_MODE.MONTHLY)) {
    initialDate = cloneDate(startDateMoment);
    initialMode = SCHEDULE_MODE.MONTHLY;
  }

  if (!isWeeklyDaily && (isMobileView || (isScheduleRoute && includesMobilePath))) {
    initialDate = cloneDate(startDateMoment);
    initialMode = SCHEDULE_MODE.MOBILE;
    initialType = SCHEDULE_TYPE.MOBILE;
  }

  const dates = getActiveDateRange(initialDate, initialMode);

  return {
    activeDate: initialDate,
    displayedScheduleType: initialType,
    mode: initialMode,
    subject: initialSubject,
    dates,
  };
};

export const getTotalPages = (page, perPage, totalRecords) => {
  const totalRecordsPageModulo = totalRecords % perPage;
  const totalRecordsPageDivide = _.floor(totalRecords / perPage);
  return totalRecordsPageModulo > 0 ? totalRecordsPageDivide + 1 : totalRecordsPageDivide;
};
